import { createStore } from '@orderx/lab/xr/store';

interface Store {
    zoneId: number;
    zoneName: string;
    zoneHash: string;
    outletName: string;
    locationName: string;
}

const { useStore } = createStore<Store>();

export function useZoneLastVisited() {
    const [zoneLastVisited, setZoneLastVisited] = useStore();

    return {
        zoneLastVisited,
        setZoneLastVisited,
        reset() {
            setZoneLastVisited(undefined as any);
        },
    };
}
